
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiBadgeEditorDialog extends Serenity.Extensions.GridEditorDialog<ProdottiBadgeRow> {
        protected getFormKey() { return ProdottiBadgeForm.formKey; }
        protected getIdProperty() { return ProdottiBadgeRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiBadgeRow.localTextPrefix; }

        protected form = new ProdottiBadgeForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            //
            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            }

            return buttons;
        }
    }
}